// @flow

import { types as T } from '../actions/action_types';
import { setIn, updateIn, compose } from '../common/utils';

const initialState = {
  route: null,
  isLoading: false,
  header: {
    title: 'Smart Image Gallery',
    left: null,
    right: null
  },
  internalStack: [],
  gallery: {
    search: {},
    detail: {}
  },
  categories: {
    list: []
  },
  settings: {
    detail: []
  },
  userData: {
    store: null,
    userInfo: null,
  },
};

const sortList = (list, key, sortType) => {
  const sign = sortType === 'asc' ? 1 : -1;
  const copy = list.slice();

  copy.sort((a, b) => {
    if (a[key] < b[key]) return -1 * sign;
    if (a[key] > b[key]) return 1 * sign;
    return 0;
  });

  return copy;
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case T.LOAD_GALLERY_REQUEST:
    case T.LOAD_UNTAGGED_REQUEST:
    case T.LOAD_GALLERY_PHOTO_REQUEST:
    case T.LOAD_CATEGORIES_REQUEST:
    case T.LOAD_SETTINGS_REQUEST:
      state = {
        ...state,
        isLoading: true
      };
      break;

    case T.LOAD_GALLERY_FAIL:
    case T.LOAD_GALLERY_SUCCESS:
    case T.LOAD_UNTAGGED_FAIL:
    case T.LOAD_UNTAGGED_SUCCESS:
    case T.LOAD_GALLERY_PHOTO_FAIL:
    case T.LOAD_GALLERY_PHOTO_SUCCESS:
    case T.LOAD_CATEGORIES_FAIL:
    case T.LOAD_CATEGORIES_SUCCESS:
    case T.LOAD_SETTINGS_FAIL:
    case T.LOAD_SETTINGS_SUCCESS:
      state = {
        ...state,
        isLoading: false
      };
      break;
    default:
      state = {
        ...state,
        isLoading: false
      };
  }

  switch (action.type) {
    case T.SET_ROUTE: {
      return {
        ...state,
        route: action.data
      };
    }

    case T.SET_HEADER: {
      return {
        ...state,
        header: {
          ...state.header,
          ...action.data
        }
      };
    }

    case T.LOAD_GALLERY_SUCCESS: {
      const key = 'photoNum';
      const sortType = 'dsc';
      const data = action.data.searchGallery || {};
      const sorted = sortList(data.Items || [], key, sortType);
      data.Items = sorted;
      return setIn(['gallery', 'search'], data, state);
    }

    case T.LOAD_UNTAGGED_SUCCESS: {
      const key = 'photoNum';
      const sortType = 'dsc';
      const data = action.data.searchGallery || {};
      const sorted = sortList(data.Items || [], key, sortType);
      data.Items = sorted;
      return setIn(['gallery', 'search'], data, state);
    }

    case T.LOAD_GALLERY_PHOTO_SUCCESS: {
      return setIn(['gallery', 'detail'], action.data.gallery, state);
    }

    case T.LOAD_UNTAGGED_PHOTO_SUCCESS: {
      return setIn(['gallery', 'detail'], action.data.gallery, state);
    }

    case T.LOAD_CATEGORIES_SUCCESS: {
      return setIn(['categories', 'list'], action.data.categories, state);
    }

    case T.LOAD_SETTINGS_SUCCESS: {
      return setIn(['settings', 'detail'], action.data.settings, state);
    }

    case T.PUSH_TO_INTERNAL_STACK: {
      return {
        ...state,
        internalStack: [...state.internalStack, action.data]
      };
    }

    case T.POP_FROM_INTERNAL_STACK: {
      return {
        ...state,
        internalStack: state.internalStack.slice(0, -1)
      };
    }

    case T.CLEAR_INTERNAL_STACK: {
      return {
        ...state,
        internalStack: []
      };
    }
    
    case T.CLEAR_APP_DATA: {
      return {
        ...initialState,
        route: state.route
      };
    }

    case T.SET_USER_DATA: {
      return {
        ...state,
        userData: {
          ...state.userData,
          ...action.data
        }
      };
    }

    case T.SET_ORDER_FORM_DATA: {
      return updateIn(
        ['userData', 'orderForm'],
        (data) => ({ ...data, ...action.data }),
        state
      );
    }

    case T.SET_LOADING: {
      return {
        ...state,
        isLoading: action.data
      };
    }

    default:
      return state;
  }
}
